/*
For messages that has only a variant like:
      "warning: 'Warnings'"
use: "<template> <h1>{{ $t('message.warning') }}, it is danger!</h1> </template>" syntax to obtain:
Warning, it is danger!

Else if message contains multiple options divided by "|" like:
      "key: 'Key | Keys'"
use: "<template> <h1>There are: 5 {{ $tc('message.warning', 2) }}</h1> </template>" syntax to obtain:
There are: 5 Keys

File input "Browse" button changing by css, edit in App.vue .lang-en { content: "Browse"} or .lang-it { content: "Cerca"}

If need to change default language see prop/language.js
 */
import Vue from 'vue'

const BASE_URL_FRONTEND = Vue.getBaseUrlFrontend().trim()
const messages = {
  en: {
    message: {
      motivation: 'Motivation|Motivations',
      day: 'Day|Days',
      lastFunction: 'Last function|Last functions',
      period: 'Period | Periods',
      stop: 'Stop | Stops',
      range: 'Range, Ranges',
      hour: 'Hour | Hours',
      address: 'Address',
      duration: 'Duration',
      equalOrMore: 'Equal and more',
      equalOrLess: 'Equal or less',
      theNotification: 'The notification',
      message: 'Message',
      deleting: 'Deleting',
      pathNotActive: 'Current user has not enough permissions, request more permissions to default admin',
      adminDefault: 'Default Admin',
      vehiclesThat: 'Vehicle that',
      create: 'Create',
      read: 'Read',
      home: 'Home',
      section: 'Section',
      user_type: 'User type',
      passwordCheck: 'Password confirm',
      userType: 'User type',
      fullName: 'Full name',
      username: 'Username',
      admin: 'Admin | Admins',
      operator: 'Operator | Operators',
      role: 'Role | Roles',
      page: 'Page | Pages',
      critical: 'Critical',
      important: 'Important',
      notImportant: 'Not important',
      level: 'Level',
      methodType: 'Method type',
      document_type: 'Document type',
      accident_state: 'Status accident',
      vehicle_state: 'Vehicle status',
      service_type: 'Service type',
      registry_code: 'ALBO code',
      fuel_type: 'Fuel type',
      activity_sector: 'Activity sector',
      driving_license: 'Driving licence',
      insurance_company: 'Insurance company',
      classification: 'Classification',
      get: 'Seen',
      post: 'Created',
      put: 'Updated',
      patch: 'Updated',
      delete: 'Deleted',
      interface: 'Interface',
      success: 'Success',
      function: 'Function | Functions',
      position: 'Position | Positions',
      log: 'Log | Logs',
      pin: 'Pin',
      expDate: 'Exp date',
      has: 'Has',
      hasNot: 'Hasn\'t',
      vehicleThat: 'Vehicle that',
      owner: 'Owner',
      power: 'Power',
      albo: 'Authorized category',
      albo2: 'Waste',
      sessionExpired: 'Session has been inactive for more than 15 minutes, please log in again',
      forbidden: 'Access denied',
      tokenExpired: 'Session is expired',
      navigate: 'Navigate',
      login: 'Login | Login',
      ok: 'Ok',
      logout: 'Logout | Logout',
      organization: 'Organization | Organizations',
      configuration: 'Configuration | Configurations',
      test: 'Test | Tests',
      table: 'Table | Tables',
      chart: 'Chart | Charts',
      assignment: 'Assignment',
      key: 'Key | Keys',
      vehicle: 'Vehicle | Vehicles',
      registry: 'Registry | Registries',
      person: 'Person | People',
      attachment: 'Attachment | Attachments',
      management: 'Management',
      operation: 'Operation | Operations',
      rental: 'Rental | Rentals',
      service: 'Service | Services',
      insurance: 'Insurance | Insurance',
      accident: 'Accident | Accidents',
      society: 'Society | Societies',
      code: 'Code | Codes',
      property: 'Property | Properties',
      status: 'Status | Status',
      sector: 'Sector | Sectors',
      activity: 'Activity | Activities',
      unlock: 'Unlock',
      vehicleUsage: 'Vehicle usage',
      type: 'Type | Types',
      document: 'Document | Documents',
      refueling: 'Refueling | Refueling',
      user: 'User | Users',
      password: 'Password',
      contact: 'Contact | Contacts',
      search: 'Search | Search',
      close: 'Close',
      clear: 'Clear',
      select: 'Select',
      unselect: 'Unselect',
      all: 'All',
      numberPlate: 'Number plate | Number plates',
      model: 'Model | Models',
      add: 'Add',
      added: 'Added|Added',
      example: 'Eg | Eg',
      insuranceCompany: 'Insurance company',
      emptyText: 'There\'s no items',
      emptyFilteredText: 'No items found',
      row: 'Row | Rows',
      selectOption: 'Select Option',
      noOption: 'Options not found',
      edit: 'Edit',
      data: 'Data',
      details: 'Details',
      equipment: 'Equipment',
      disable: 'Disable',
      disabled: 'Disabled | Disabled | Disabled',
      enable: 'Enable',
      enabled: 'Enabled | Enabled | Enabled',
      save: 'Save',
      saveClose: 'Save and close',
      chain: 'Chain | Chains',
      rescue: 'Rescue',
      cid: 'FAS',
      airConditioning: 'Air conditioning',
      firstAidKit: 'First aid kit',
      seasonalTires: 'Tires',
      date: 'Date',
      registration: 'Registration',
      userCompany: 'User company',
      serialNumber: 'Serial Number',
      fuel: 'Fuel | Fuels',
      matriculation: 'Matriculation | Matriculations',
      tax: 'Tax | Tax',
      begin: 'Begin | Begin',
      actual: 'Actual | Actual',
      update: 'Update | Updates',
      info: 'Info',
      warning: 'Warnings',
      error: 'Error',
      note: 'Note | Notes',
      page404: 'Sorry, page not found',
      required: 'Required | Required',
      description: 'Description',
      customer: 'Customer',
      done: 'Done | Done',
      sold: 'Sold',
      spent: 'Spent',
      caution: 'Caution',
      upload: 'Upload',
      chassisNumber: 'Chassis number',
      engineDisplacement: 'Engine displacement',
      purchase: 'Purchase',
      price: 'Price | Price',
      length: 'Length',
      width: 'Width',
      payload: 'Payload',
      trailerHitch: 'Trailer hitch',
      emissionStandard: 'Emission standard',
      maxWeight: 'Max weight',
      vehicleSetUp: 'Equipment',
      brand: 'Brand',
      seats: 'Seats',
      obu: 'OBU',
      item: 'Item',
      not: 'Not',
      deleteCheck: 'Are you sure to delete item',
      continue: 'Continue',
      avgConsumption: 'Average consumption',
      start: 'Start',
      end: 'End',
      redemptionPrice: 'Redemption price',
      max: 'Max | Max',
      min: 'Min | Min',
      year: 'Year',
      loanerVehicle: 'Loaner vehicle',
      towTruck: 'Tow truck',
      relief: 'Relief',
      postSuccess: 'Item is created',
      putSuccess: 'Item is updated',
      behalfOf: 'Behalf of',
      estimated: 'Estimated | Estimated',
      number: 'Number',
      essentialData: 'Essential data',
      extraData: 'Extra data',
      inOperation: 'In operation',
      costPerKm: 'Cost per km',
      expiration: 'Expiration',
      loan: 'Loan',
      leasing: 'Leasing',
      payment: 'Payment',
      installment: 'Installment',
      frequency: 'Frequency',
      workInProgress: 'Work in progress ...',
      removed: 'Removed',
      yes: 'Yes',
      no: 'No',
      nowCheckedOnVehicle: 'Manually checked',
      automaticCheck: 'Automatically checked',
      last: 'Last',
      first: 'First',
      refresh: 'Refresh',
      identityData: 'Identity data',
      priceYear: 'Price for year',
      yearly: 'Yearly',
      semiannual: 'Semiannual',
      quarterly: 'Quarterly',
      monthly: 'Monthly',
      survey: 'Survey',
      keyNumber: 'Number of keys',
      hasOBU: 'Has OBU',
      noOBU: 'No OBU assigned',
      noDate: 'No date',
      report: 'Report',
      interactiveMap: 'Interactive map',
      emptyValue: '- - - - -',
      associate: 'Associate',
      dissociate: 'Dissociate',
      availableOBU: 'Available OBU',
      ordinary: 'Ordinary',
      extraOrdinary: 'Extra ordinary',
      causal: 'Causal',
      scheduled: 'Scheduled',
      new: 'New | New',
      configureNotification: 'Configure notification',
      driver: 'Driver',
      appointee: 'Appointee',
      addNewOperationByCause: 'Add new operation by cause',
      forThisVehicle: 'For this vehicle',
      in: 'In',
      month: 'Month | Months',
      withExpirationDate: 'With expiration date',
      uponReachingCertain: 'Upon reaching certain',
      scheduledButNoExecuted: 'Scheduled but not executed',
      inDate: 'In date',
      or: 'Or',
      atKm: 'At km',
      reschedule: 'Reschedule operation',
      hasMail: 'Automatic mail | Automatic mails',
      noMailConfig: 'Notifications not configured',
      noSave: 'Don\'t save',
      cancel: 'Cancel',
      unsavedChanges: 'Redirect in progress, there are some changes.',
      newOperationRedirect: 'New operation will be create, would you remain on current operation or want to be redirect to new one ?',
      remain: 'Remain',
      redirect: 'Redirect to',
      coordinates: 'Coordinates',
      list: 'List',
      associated: 'Associated',
      available: 'Available | Available',
      found: 'Found | Found',
      when: 'When',
      notification: 'Notification | Notifications | notification',
      and: 'And',
      reminder: 'Reminder',
      shortcut: 'Shortcut | Shortcuts',
      show: 'Show',
      hide: 'Hide',
      shown: 'Shown | Shown',
      hidden: 'Hidden | Hidden',
      filter: 'Filter | Filters',
      realTime: 'Real time',
      travel: 'Travel',
      traveledHistory: 'Travel history',
      history: 'History',
      calendar: 'Calendar',
      searchBy: 'Search by',
      filterBy: 'Filter by',
      instruments: 'Instruments',
      nexRefresh: 'Next refresh',
      engineStatus: 'Engine status',
      engine: 'Engine',
      on: 'On',
      off: 'Off',
      latitude: 'Latitude',
      longitude: 'Longitude',
      commission: 'Commission',
      hired: 'Hired | Hired',
      km: 'Km',
      remaining: 'Remaining | Remaining',
      exceededBy: 'Exceeded by',
      missed: 'Missed | Missed',
      own: 'Own',
      thirdParties: 'Third parties',
      surname: 'Surname',
      taxCode: 'Tax code',
      drivingLicense: 'Driving licence',
      badgeNumber: 'Badge number',
      contract: 'Contract',
      contractData: 'Contract data',
      resign: 'Resign',
      resigned: 'Resigned',
      keyCode: 'Key code',
      staff: 'Staff',
      damage: 'Damage',
      place: 'Place',
      compensation: 'Compensation',
      measures: 'Measures',
      counterpart: 'Counterpart',
      name: 'Name',
      resetFilters: 'Reset filters',
      maxLength: 'Max length',
      maxValue: 'Max value',
      import: 'Import',
      selectFile: 'Select file',
      browse: 'Browse',
      importSuccess: 'Successful import',
      notFound: 'Not found',
      company: 'Company',
      type2: 'Type | Types',
      isADuplicateOfRow: 'Is a duplicate of row',
      asset: 'Asset | Assets',
      recipient: 'Recipient | Recipients',
      fleet: 'Fleet | Fleets',
      recipients: 'Recipient | Recipients',
      reminderGroup: 'Reminder group',
      notificationGroup: 'Notification group',
      email: 'Email',
      summary: 'Summary',
      saveAndContinue: 'Save and continue',
      continueNoSave: 'Continue without saving',
      noGroupConfigured: 'Notification and reminder group are not configured',
      expired: 'Expired | Expired',
      notified: 'Notified',
      theService: 'The service | The services',
      ofVehicle: 'Of vehicle',
      needSupervision: 'Need supervision due to expiration date is',
      needSupervision2: 'Need supervision due to expiration',
      withCausal: 'With causal',
      alreadyExist: 'Already exist',
      from: 'From',
      to: 'To',
      manual: 'Manual',
      automatic: 'Automatic',
      threshold: 'threshold',
      warningThreshold: 'Warning threshold',
      dateFormat: 'yyyy-MM-dd',
      penaltyChargeNotice: 'Penalty charge notice',
      linkedViolationID: 'Linked penalty charge notice ID',
      violation: 'Penalty charge notice list',
      verbalNumber: 'Verbal number',
      verbalDate: 'Verbal date',
      issuedBy: 'Issued by',
      infringementDate: 'Infringement date',
      infringementTime: 'Infringement time',
      infringement: 'Infringement',
      locality: 'Locality',
      penaltyChargeNoticeAmount: 'Penalty charge notice amount',
      paymentDeadline: 'Payment deadline',
      drivingLicensePointsCharge: 'Driving license points charge',
      reducedAmount: 'Reduced amount',
      reducedPaymentDeadline: 'Reduced payment deadline',
      violationStatus: 'Penalty charge notice status',
      dispute: 'Dispute | dispute',
      employeeNotification: 'Employee notification',
      verification: 'Verification',
      violationID: 'Penalty charge notice ID',
      violationData: 'Penalty charge notice data',
      timeFormat: 'hh:mm',
      paymentDate: 'Payment date',
      paymentMethod: 'Payment method',
      payedAmount: 'Payed amount',
      paymentReceipt: 'Payment receipt',
      paymentRegistration: 'Payment registration',
      notificationCondition: 'Notification condition',
      driverID: 'Driver ID',
      subjectToWithholding: 'Subject to withholding',
      debitAuthorization: 'Debit authorization',
      modelOf: 'Model of',
      installmentPayment: 'Installment payment',
      deductionOfDrivingLicensePoints: 'Deduction of driving license points',
      notificationMailAddress: 'Notification mail address',
      otherMailAddress: 'Other mail address',
      ccAdministration: 'CC administration',
      notificationSendDate: 'Notification sent date',
      send: 'Send',
      conditions: 'Condition of',
      mailAddressOfTheFileManagementClerk: 'Mail address of the file management clerk',
      deadlines: 'Deadline',
      forward: 'Forward',
      inserting: 'Inserting',
      detected: 'Detected',
      speed: 'Speed',
      set: 'Set',
      practice: 'Practice',
      download: 'Download',
      reopen: 'Reopen',
      verificationStatus: 'Verification status',
      courtesyMessageTable: 'There are no records',
      penaltyChargeNoticeManagement: 'Penalty charge notice',
      telephoneNumber: 'Telephone number',
      consensus: 'Consensus',
      exemption: 'Exemption',
      chargeable: 'Chargeable',
      authorized: 'Authorized from',
      responsible: 'Responsible',
      tool: 'Tool',
      tag: 'Tag',
      notTransmitting: 'Not transmitting',
      lastTransmissionDate: 'Last transmission date',
      oneWeek: 'One week',
      oneMonth: 'One month',
      threeMonths: 'Three months',
      customize: 'Customize',
      transmittingLabel: 'Do not transmit from',
      verifyTransmissionOBU: 'OBU verify transmission',
      associatedVehicle: 'Associated vehicle',
      selectTimer: 'Select timer in seconds'
    },
    info: {
      dataUsedByUser: 'Data used by user',
      noLogsInLast: 'There are no function used in last ',
      driverNotAssociated: 'Is not associated',
      vehicleAlreadyDisabled: 'The vehicle is disabled before notification date',
      schedulingDateIsLessThanToday: 'It is not possible to enable notification for a date before than today',
      canNotDisableIfHasOBU: 'Remove OBU before disabling vehicle',
      areYouSureTo: 'Are you sure to',
      allConfigsAreSelected: 'Default Admin will have all config permissions',
      disableUserCheck: 'Are you sure to disable',
      operatorCanModifyOnlyOperators: 'Your user can delete only Operator users',
      canNotDisableAnotherAdmin: 'Can not disable another admin',
      operationMandatoryInfo1: 'To have a proper management of operations\' expirations, it’s necessaty to assign a value to at least one of the fields between',
      operationMandatoryInfo2: 'After the mail addresses are configured in the section',
      operationMandatoryInfo3: 'it will be possible to receive, for each upcoming expiration related to a',
      operationMandatoryInfo4: 'date and / or a certain distance in kilometres',
      operationMandatoryInfo5: 'an e-mail message as a',
      operationMandatoryInfo6: 'with',
      operationMandatoryInfo7: 'vehicles\' maintenance main informations',
      runningOut: 'Running out km',
      exhaustedKm: 'Exhausted km',
      regular: 'Regular km situation',
      notDefinable: 'Not definable',
      infoModal: 'Specific information',
      vehicleHasKm: 'The vehicle still has more than',
      missingLessThan: 'Missing less than',
      vehicleRegularStatus: 'The vehicle is far from reaching the maximum mileage set for rental',
      vehicleIsRunningOut: 'The vehicle is close to reaching the maximum mileage set for rental',
      vehicleRentalExhausted: 'The vehicle has exceeded the viable limit set in the rental drivable distance',
      updateVehicleAutomaticDate: 'The km detected by the GPS are aligned daily at 02:00 and are synchronized with the last mileage entered manually.',
      driverResigned: 'The driver is currently discharged',
      emptyPositions: 'Positions non found',
      needAtLeastOneEmail: 'At least a valid e-mail is required',
      willBeEnabledNotification: 'Will be enabled automatic notification by the current configuration',
      toChangeConfig: 'To change configuration click shortcut',
      threshold: '',
      notificationEnabled: 'The operation will be notified by e-mail by notification and reminder groups configurations',
      notificationDisabled: 'The operation will NOT be notified',
      remainingKmInfo1: 'The function returns all vehicles having contract using a max drivable km as restriction,' +
        'that must be insert in vehicle\'s registry.',
      remainingKmInfo2: 'Inserting',
      remainingKmInfo3: 'in this filter field,' +
        ' you will get all vehicles that has km as restriction equal or less than at the selected value.',
      remainingKmInfo4: 'EX: Setting value to 30.000 KM you will get all vehicles that has ' +
        ' still a useful distance less or equal to 30.000 Km respect the contracted value (GREEN sticker)\n' +
        'If contracted km has exceeded will be present a sticker (RED sticker)\n' +
        'The selection can be further refined (see the field',
      thresholdInfoModal1: 'Setting a value of',
      thresholdInfoModal2: 'Will be shown the evidence (YELLOW sticker) of those vehicles' +
        '(although they fall within the selection made through the value',
      thresholdInfoModal3: 'have a number of Km remaining with respect to the contract that is less than or equal to the threshold value,',
      thresholdInfoModal4: 'This field can be used to automatically to highlight ' +
        'the most critical situations within the selected vehicle group.\n' +
        'The situation obtained can be exported for processing or reports of various kinds.\n',
      thresholdInfoModal5: 'The list of vehicles that have a residual distance of at least 30,000 km (or less) is obtained' +
        ' with the evidence (YELLOW sticker) of those that have a residual distance less than or equal to 2,500 km.',
      enumConfig1: 'Warning: ' +
        'the modification or cancellation of the email addresses associated with the service will not be applied to notification requests already active.',
      enumConfig2: 'The new addresses will be used in the next activations.',
      hasService: 'Has service',
      hasNoService: 'Hasn\'t service',
      allFieldsInPositionReportRequired: 'Please fill all fields to start a new search (max 12 hours range)',
      awdocAuthorized: 'To view and upload attachments, you must log in with your credentials at the address ' + BASE_URL_FRONTEND + '/awdoc'
    },
    success: {
      postSuccess: 'correctly added',
      putSuccess: 'correctly modified',
      sendMail: 'correctly sended',
      fileUpload: 'File uploaded correctly',
      fileDeleted: 'File deleted correctly',
      fileDownloaded: 'File downloaded correctly'
    },
    warnings: {
      motivationRequired: 'To comply with privacy regulations, it is necessary to select one of the reasons provided for the access to the type of data requested',
      adminCanNotEditDefaultAdmin: 'Admin users are not abled to edit "Default Admin"',
      atLeastDefaultAdminNeeded: 'Application require at least "Default Admin" to correctly work',
      adminCanOnlyCreateOtherAdmins: 'An administrator can only create other administrators',
      accessDenied: 'Access denied',
      alreadyDisabled: 'User is already disabled',
      checkDate: 'Error on date, check before save',
      canNotBeBefore: 'can note be before | can note be before',
      dateError: 'Date error',
      sureToDelete: 'Are you sure to delete item',
      continue: 'Continue',
      invalid: 'Invalid | Invalid',
      valid: 'Valid | Valid',
      notSavedTabChanges: 'There are unsaved changes in this tab. Do you want to continue?',
      onlyExcel: 'xls, xlsx or ods file authorized only',
      fileHasDifferentLang: 'The file\'s language diverging from the browser\'s language. Change file or browser language.',
      fileIsEmpty: 'The file is empty',
      association: 'Error during association between',
      serviceNotFound: 'Service not found',
      resetSavedPosition: 'By saving the new information, the previously acquired position will be lost, continue?',
      chooseStatus: 'It is mandatory to choose a state for verification:',
      disputeNotSavable: 'It is not possible to file a dispute as the verification is accepted',
      notificationNotSavable: 'It is not possible to notify the employee because one or more notification conditions are not met',
      verificationNotReopenable: 'It is not possible to reopen verification: ',
      employeeNotificationSent: 'the reimbursement notification has already been sent to the employee',
      disputeSent: 'the dispute has already been sent'
    },
    errors: {
      noStaffAdd: 'Current user has not the rights to create staff members',
      noStaffEdit: 'Current user has not the rights to edit staff members',
      userIsDisabled: 'Your user is disabled, talk to an administrator.',
      inUse: 'Selected item has already been used and can not be removed',
      generic: 'Something went wrong',
      unusual: 'Item already created',
      login: 'Wrong username or password',
      surnameLength: 'Surname(*) error, it is required and has 50 characters of max length',
      nameLength: 'Name(*) error, it is required and has 50 characters of max length',
      taxCode: 'Tax code error, is invalid',
      badgeLength: 'Badge error, it has 20 characters of max length',
      keyCodeError: 'Key code error, it has 40 characters of max length',
      invalidDate: 'Is an invalid date (YYYY-MM-DD)',
      invalidContractData: 'contractual dates are chronologically invalid',
      errorsList: 'Errors list',
      duplicateTaxCode: 'The tax code is already present in system',
      fileUpload: 'File not uploaded',
      fileDeleted: 'File not deleted',
      fileDownloaded: 'File not downloaded',
      fileFormat: 'Inserted file hasn\'t a valid format'
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    constraints: {
      user_name: 'Duplicate username',
      contract_number: 'Duplicate contract number',
      tracker_imei: 'Duplicate IMEI',
      vehicle_plate: 'Plate number already in system',
      vehicle_tracker: 'Tracker associated with multiple vehicles',
      asset_tag: 'Duplicate TAG code',
      asset_code: 'Duplicate tool code',
      enum_descr: 'Duplicate enumeration description',
      recipient_descr: 'Duplicate recipient description'
    },
    dimetiorHttpCode: {
      400: {
        2: 'Error reading or interpreting an input parameter',
        10: 'Error during insertion or modification of an entity due to the violation of a uniqueness constraint',
        11: 'Error during insertion or modification of an entity due to the violation of a constraint on one or more columns'
      },
      403: 'Access denied',
      404: {
        0: 'Resource not found',
        3: 'Resource not found'
      },
      409: {
        7: 'Conflict during removal'
      },
      413: 'Data size too large',
      422: {
        3: 'Error during communication'
      },
      423: 'The password has expired',
      440: 'The session has expired',
      500: {
        1: 'Unexpected server side error',
        4: 'Key not allowed',
        5: 'Not enough space to add a new key',
        6: 'Key is being edited',
        7: 'Incorrect key index',
        8: 'Unable to update tracker information',
        9: 'The command could not be updated'
      },
      502: 'Error 502, communication error'
    },
    violazioniHttpCode: {
      400: {
        1: 'Invalid key value',
        2: 'Error during insertion or modification of an entity due to the violation of a uniqueness constraint',
        3: 'Error inserting or modifying an entity due to the violation of a uniqueness constraint'
      },
      401: 'Could not connect to the penalty charge notice server',
      403: 'Access denied',
      404: {
        5: 'Resource not found'
      },
      409: {
        4: 'Error inserting or editing an entity due to a constraint violation'
      },
      422: {
        2: 'Error validating the entity sent in the request body'
      },
      500: {
        6: 'Internal server error'
      }
    },
    path: {
      '/recipients': 'Recipients',
      '/insurance': 'Insurance',
      '/home': 'Home',
      '/map': 'Interactive map',
      '/organization': 'organization',
      '/configuration': 'configuration',
      '/obu_management': 'Management OBY',
      '/logout': 'Exit',
      '/login': 'Login',
      '/application_logs': 'Log',
      '/customer': 'User',
      '/customers': 'Users',
      '/user': 'User',
      '/users': 'User',
      '/trackers': 'OBU',
      '/position': 'Position',
      '/positions': 'Positions',
      '/vehicles': 'Vehicle',
      '/operations': 'Operation',
      '/scheduling': 'Operation',
      '/accidents': 'Accident',
      '/drivers': 'Staff',
      '/driversbyvehicle': 'Staff',
      '/alarm': 'Alarm',
      '/alarmdefs': 'Alarm',
      '/device_command': 'OBU config',
      '/fleets': 'Fleet',
      '/recipients_list': 'Recipient',
      '/report': 'Report',
      '/assets': 'Asset',
      '/tags': 'Tag',
      '/blescans': 'Scan',
      '/lastscans': 'Scan',
      '/warehouses': 'Warehouses',
      '/enums/document_type': 'Document type',
      '/enums/fuel_type': 'Fuel type',
      '/enums/owner': 'owner',
      '/enums/insurance_company': 'Insurance company',
      '/enums/company': 'Company',
      '/enums/vehicle_state': 'Vehicle state',
      '/enums/activity_sector': 'Activity sector',
      '/enums/registry_code': 'Registry code',
      '/enums/service_type': 'Service type',
      '/enums/equipment': 'Equipment',
      '/enums/classification': 'Classification',
      '/enums/accident_state': 'Accident state',
      '/enums/asset_type': 'Asset type',
      '/enums/driving_license': 'Driving licence',
      '/enums/operation': 'Operation',
      '/enums/user_type': 'User type',
      '/penalty_charge_notice': 'Penalty charge notice',
      '/motivations_registry': 'Motivations registry'
    },
    motivation: {
      assessment: 'Road and / or administrative assessment',
      assistance: 'Assistance to the driver',
      securityCheck: 'Suspected theft',
      availableCheck: 'Check vehicle availability',
      parkingCheck: 'Parking location',
      OBUCheck: 'check OBU operation'
    }
  },
  it: {
    message: {
      motivation: 'Motivazione|Motivazioni',
      day: 'Giorno|Giorni',
      lastFunction: 'Ultima funzione|Ultime funzioni',
      period: 'Periodo | Periodi',
      stop: 'Sosta | Soste',
      range: 'Intervallo | Intervalli',
      hour: 'Ora | Ore',
      address: 'Indirizzo',
      duration: 'Durata',
      equalOrMore: 'Maggiore o uguale',
      equalOrLess: 'Minore o uguale',
      theNotification: 'La notifica',
      message: 'Messaggio',
      pathNotActive: 'Non si è in possesso dei permessi necessari, rivolgersi all\'amministratotre di default.',
      adminDefault: 'Admin di default',
      vehiclesThat: 'Veicolo che',
      create: 'Creazione',
      read: 'Lettura',
      home: 'Home',
      section: 'Sezione',
      passwordCheck: 'Conferma password',
      userType: 'Tipologia utente',
      fullName: 'Nome completo',
      username: 'Username',
      admin: 'Amministratore | Amministratori',
      operator: 'Operatore | Operatori',
      role: 'Ruolo | Ruoli',
      page: 'Pagina | Pagine',
      critical: 'Critico',
      important: 'Importante',
      notImportant: 'Non importante',
      level: 'Livello',
      methodType: 'Tipo richiesta',
      document_type: 'Tipologia documento',
      classification: 'Classificazione',
      insurance_company: 'Compagnia assicurativa',
      service_type: 'Tipologia servizio',
      registry_code: 'Codice ALBO',
      fuel_type: 'Tipologia carburante',
      activity_sector: 'Settore attività',
      driving_license: 'Tipologia patente',
      accident_state: 'Stato incidente',
      vehicle_state: 'Stato veicolo',
      get: 'Visualizzato',
      post: 'Aggiunto',
      put: 'Aggiornato',
      patch: 'Aggiornato',
      delete: 'Eliminato',
      deleting: 'Eliminazione',
      interface: 'Interfaccia',
      success: 'Successo',
      function: 'Funzione | Funzioni',
      position: 'Posizione | Posizioni',
      log: 'Log | Logs',
      pin: 'Pin',
      expDate: 'Data scadenza',
      has: 'Possiede',
      hasNot: 'Non possiede',
      vehicleThat: 'Veicolo che',
      owner: 'Proprietario',
      power: 'Potenza',
      albo: 'Albo',
      albo2: 'Gestore ambientale',
      sessionExpired: 'La sessione risulta inattiva da più di 15 minuti, eseguire nuovamente l\'accesso',
      forbidden: 'Accesso negato',
      tokenExpired: 'La sessione risulta scaduta',
      navigate: 'Navigazione',
      login: 'Accesso | accessi',
      ok: 'Ok',
      logout: 'Uscita | Uscite',
      organization: 'Organizzazione | Organizzazioni',
      configuration: 'Configurazione | Configurazioni',
      test: 'Prova | Prove',
      table: 'Tabella | Tabelle',
      chart: 'Grafico | Grafici',
      assignment: 'Assegnazione',
      key: 'Chiave | Chiavi',
      vehicle: 'Veicolo | Veicoli',
      registry: 'Anagrafica | Anagrafiche',
      person: 'Persona | persone',
      attachment: 'Allegato | Allegati',
      management: 'Gestione',
      operation: 'Intervento | Interventi',
      rental: 'Noleggio | Noleggi',
      service: 'Servizio | Servizi',
      insurance: 'Polizza | Polizze | Elenco polizze',
      accident: 'Sinistro | Elenco sinistri',
      society: 'Società | Società',
      code: 'Codice | Codici',
      property: 'Proprietà | Proprietà',
      status: 'Stato | Stati',
      sector: 'Settore | Settori',
      activity: 'Attività | Attività',
      unlock: 'Sblocco',
      vehicleUsage: 'Formule d\'uso',
      type: 'Tipologia | Tipologie',
      document: 'Documento | Documenti',
      refueling: 'Rifornimento | Rifornimenti',
      user: 'Utente | Utenti',
      password: 'Password',
      contact: 'Contatto | Contatti',
      search: 'Ricerca | Ricerche',
      close: 'Chiudi',
      clear: 'Cancella',
      select: 'Seleziona',
      unselect: 'Deseleziona',
      all: 'Tutti',
      numberPlate: 'Targa | Targhe',
      model: 'Modello | Modelli',
      add: 'Aggiungi',
      added: 'Aggiunto|Aggiunta',
      example: 'Es | Es',
      insuranceCompany: 'Compagnia assicurativa',
      emptyText: 'Non ci sono elementi presenti',
      emptyFilteredText: 'La ricerca non ha prodotto risultati',
      row: 'Riga | Righe',
      selectOption: 'Selezionare un\'opzione',
      noOption: 'Opzioni non disponibili',
      edit: 'Modifica',
      data: 'Dati',
      details: 'Dettaglio',
      equipment: 'Dotazioni',
      disable: 'Disabilita',
      disabled: 'Disabilitato | Disabilitazione | Disabilitata',
      enable: 'Abilita',
      enabled: 'Abilitato | Abilitazione | Abilitata',
      enabling: 'Abilitare',
      disabling: 'Disabilitare',
      save: 'Salva',
      saveClose: 'Salva e chiudi',
      chain: 'Catena | Catene',
      rescue: 'Soccorso',
      cid: 'CID',
      airConditioning: 'Clima',
      firstAidKit: 'Kit pronto soccorso',
      seasonalTires: 'Gomme',
      date: 'Data',
      registration: 'Iscrizione',
      userCompany: 'Società utilizzatrice',
      serialNumber: 'Numero di serie',
      fuel: 'Alimentazione | Alimentazioni',
      matriculation: 'Immatricolazione | Immatricolazioni',
      tax: 'Fiscale | Fiscali',
      begin: 'Iniziale | Iniziali',
      actual: 'Attuale | Attuali',
      update: 'Aggiornamento | Aggiornamenti',
      info: 'Informazione',
      warning: 'Attenzione',
      error: 'Errore',
      note: 'Nota | Note',
      page404: 'Ops, pagina non trovata',
      required: 'Obbligatorio | Obbligatoria',
      description: 'Descrizione',
      customer: 'Cliente',
      done: 'Eseguito | Eseguita',
      sold: 'Venduto',
      spent: 'Speso',
      caution: 'Attenzione',
      upload: 'Caricamento',
      chassisNumber: 'Numero di telaio',
      engineDisplacement: 'Cilindrata',
      purchase: 'Acquisto',
      price: 'Prezzo | Conto',
      length: 'Lunghezza',
      width: 'Larghezza',
      payload: 'Portata',
      trailerHitch: 'Gancio traino',
      emissionStandard: 'Classe emissione',
      maxWeight: 'Massa massima',
      vehicleSetUp: 'Allestimento',
      brand: 'Marca',
      seats: 'Numero posti',
      obu: 'OBU',
      item: 'Elemento',
      not: 'Non',
      deleteCheck: 'Si è sicuri di voler eliminare l\'elemento ',
      continue: 'Prosegui',
      avgConsumption: 'Consumo medio',
      start: 'Inizio',
      end: 'Fine',
      redemptionPrice: 'Prezzo di riscatto',
      max: 'Massimo | Massimi',
      min: 'Minimo | Minimi',
      year: 'Anno',
      loanerVehicle: 'Veicolo sostitutivo',
      towTruck: 'Carro attrezzi',
      relief: 'Franchigia',
      postSuccess: 'Aggiunta eseguita',
      putSuccess: 'Modifica eseguita',
      behalfOf: 'Per conto',
      essentialData: 'Dati essenziali',
      extraData: 'Dati di esercizio',
      inOperation: 'In esercizio',
      estimated: 'Stimato | Stimati',
      costPerKm: 'Costo per km',
      number: 'Numero',
      expiration: 'Scadenza',
      loan: 'Comodato d\'uso',
      leasing: 'Leasing',
      payment: 'Pagamento',
      installment: 'Importo rata',
      frequency: 'Frequenza',
      workInProgress: 'Pagina in fase di sviluppo ...',
      removed: 'Rimosso',
      yes: 'Sì',
      no: 'No',
      nowCheckedOnVehicle: 'Rilevati manualmente',
      automaticCheck: 'Rilevati automaticamente',
      last: 'Ultimo',
      first: 'Primo',
      refresh: 'Ricarica',
      identityData: 'Dati identificativi',
      priceYear: 'Premio annuale',
      yearly: 'Annuale',
      semiannual: 'Semestrale',
      quarterly: 'Trimestrale',
      monthly: 'Mensile',
      survey: 'Rilevamento',
      keyNumber: 'Numero di chiavi',
      hasOBU: 'OBU associato',
      noOBU: 'Nessun OBU associato',
      noDate: 'Nessuna data',
      report: 'Report',
      interactiveMap: 'Mappa interattiva',
      emptyValue: '- - - - -',
      associate: 'Associa',
      dissociate: 'Dissocia',
      availableOBU: 'OBU disponibili',
      ordinary: 'Ordinario',
      extraOrdinary: 'Straordinario',
      causal: 'Causale',
      scheduled: 'Schedulato',
      new: 'Nuovo | Nuova',
      configureNotification: 'Configura notifiche',
      driver: 'Autista',
      appointee: 'Incaricato',
      addNewOperationByCause: 'Aggiungi un nuovo intervento con causale',
      forThisVehicle: 'Per questo veicolo',
      in: 'Tra',
      month: 'Mese | Mesi',
      withExpirationDate: 'Con scadenza in data',
      uponReachingCertain: 'Al raggiungimento di',
      scheduledButNoExecuted: 'Schedulati ma non eseguiti',
      inDate: 'In data',
      or: 'Oppure',
      atKm: 'Al km',
      reschedule: 'Rischedula l\'intervento',
      hasMail: 'Mail automatica | Mail automatiche',
      noMailConfig: 'Invio notifiche non configurato',
      noSave: 'Non salvare',
      cancel: 'Annulla',
      unsavedChanges: 'La pagina verrà ricaricata e sono state apportate alcune modifiche.',
      valid: 'Valido | Valida',
      newOperationRedirect: 'Un nuovo intervento verrà creato, continuare sull\'intervento corrente o visualizzare il nuovo?',
      remain: 'Rimani',
      redirect: 'Visualizza nuovo',
      coordinates: 'Coordinate',
      list: 'Lista',
      associated: 'Associato',
      available: 'Disponibile | Disponibili',
      found: 'Trovato | Trovati',
      when: 'Quando',
      notification: 'Notifica | Notifiche | notifica',
      and: 'E',
      reminder: 'Promemoria',
      shortcut: 'Scorciatoia | Scorciatoie',
      show: 'Mostra',
      hide: 'Nascondi',
      shown: 'Visualizzato | Visualizzati',
      hidden: 'Nascosto | Nascosti',
      filter: 'Filtro | Filtri',
      realTime: 'Tempo reale',
      travel: 'Percorsi',
      traveledHistory: 'Storia percorsi',
      history: 'Storia',
      calendar: 'Calendario',
      searchBy: 'Ricerca per',
      filterBy: 'Filtra per',
      instruments: 'Strumenti',
      nexRefresh: 'Aggiornamento tra',
      engineStatus: 'Stato motore',
      engine: 'Motore',
      on: 'Acceso',
      off: 'Spento',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      commission: 'Commessa',
      hired: 'Noleggiato | Noleggiati',
      km: 'Km',
      remaining: 'Rimanente | Rimanenti',
      exceededBy: 'Superato da',
      missed: 'Mancante | Mancanti',
      own: 'Proprio',
      thirdParties: 'Terzi',
      surname: 'Cognome',
      taxCode: 'Codice fiscale',
      drivingLicense: 'Patente',
      badgeNumber: 'Numero badge',
      contract: 'Contratto',
      contractData: 'Dati contrattuali',
      resign: 'Dimissioni',
      resigned: 'Dimesso',
      keyCode: 'Codice chiave',
      staff: 'Personale',
      damage: 'Danno',
      place: 'Luogo',
      compensation: 'Compenso',
      measures: 'Misure',
      counterpart: 'Controparte',
      name: 'Nome',
      resetFilters: 'Pulisci filtri',
      maxLength: 'Lunghezza massima',
      maxValue: 'Valore massimo',
      import: 'Importa',
      selectFile: 'Seleziona il file',
      browse: 'Ricerca',
      importSuccess: 'Importazione avvenuta con successo',
      notFound: 'Non trovato',
      company: 'Compagnia',
      type2: 'Tipo | Tipi',
      isADuplicateOfRow: 'è un duplicato della riga',
      asset: 'Strumento | Strumenti',
      recipient: 'Destinatario | Destinatari',
      fleet: 'Flotta | flotte',
      recipients: 'Destinatario | Elenco destinatari',
      reminderGroup: 'Gruppo di promemoria',
      notificationGroup: 'Gruppo di notifica',
      email: 'Email',
      summary: 'Riepilogo',
      saveAndContinue: 'Salva e prosegui',
      continueNoSave: 'Prosegui senza salvare',
      noGroupConfigured: 'I gruppi di notifica e promemoria non sono stati configurati',
      expired: 'Scaduto | Scaduti',
      notified: 'Notificato',
      theService: 'Il servizio | I servizi',
      ofVehicle: 'Del veicolo',
      needSupervision: 'Necessita di supervisione poiché la data di scadenza è stata fissata al giorno',
      needSupervision2: 'Necessita di supervisione',
      withCausal: 'Con causale',
      alreadyExist: 'Già esistente',
      from: 'Da',
      to: 'A',
      user_type: 'Tipo utente',
      manual: 'Manuale',
      automatic: 'Automatico',
      threshold: 'Soglia',
      warningThreshold: 'Soglia di attenzione',
      dateFormat: 'dd-MM-yyyy',
      timeFormat: 'HH:mm',
      violation: 'violazione | violazioni | Elenco violazioni',
      penaltyChargeNotice: 'multa',
      violationData: 'Dati violazione',
      verification: 'Verifica',
      employeeNotification: 'Notifica dipendente',
      dispute: 'Contestazione | contestazione',
      violationID: 'ID violazione',
      linkedViolationID: 'ID Violazione collegata',
      verbalNumber: 'Numero verbale',
      verbalDate: 'Data verbale',
      issuedBy: 'Emesso da',
      infringementDate: 'Data infrazione',
      infringementTime: 'Ora infrazione',
      infringement: 'Infrazione',
      locality: 'Località',
      penaltyChargeNoticeAmount: 'Importo multa',
      paymentDeadline: 'Scadenza pagamento',
      drivingLicensePointsCharge: 'Addebito punti patente',
      reducedAmount: 'Importo ridotto',
      reducedPaymentDeadline: 'Scadenza pagamento ridotto',
      violationStatus: 'Stato violazione',
      paymentDate: 'Data pagamento',
      paymentMethod: 'Metodo pagamento',
      payedAmount: 'Importo pagato',
      paymentReceipt: 'Ricevuta pagamento',
      paymentRegistration: 'Registrazione pagamento',
      driverID: 'Identificativo autista',
      subjectToWithholding: 'Soggetto a trattenuta',
      debitAuthorization: 'Autorizzazione all\'addebito',
      modelOf: 'Modello di',
      installmentPayment: 'Pagamento rateale',
      deductionOfDrivingLicensePoints: 'Decurtazione punti patente',
      notificationMailAddress: 'Indirizzo di notifica',
      otherMailAddress: 'Altro indirizzo',
      ccAdministration: 'CC Amministrazione',
      notificationSendDate: 'Data invio notifica',
      send: 'Invia',
      conditions: 'Condizioni di',
      mailAddressOfTheFileManagementClerk: 'Indirizzo mail addetto gestione pratica',
      deadlines: 'Scadenza termini',
      forward: 'Inoltro',
      inserting: 'Inserimento',
      detected: 'Rilevata | Rilevati',
      speed: 'Velocità',
      set: 'Imposta',
      practice: 'Pratica',
      download: 'Scarica',
      reopen: 'Riapri',
      verificationStatus: 'Stato verifica',
      courtesyMessageTable: 'Non sono presenti elementi in elenco',
      penaltyChargeNoticeManagement: 'Gestione multe',
      telephoneNumber: 'Numero di telefono',
      consensus: 'Consenso',
      exemption: 'Esenzione',
      chargeable: 'Addebitabile',
      authorized: 'Autorizzato da',
      responsible: 'Responsabile',
      tool: 'Strumento',
      tag: 'Tag',
      notTransmitting: 'Non trasmittenti',
      lastTransmissionDate: 'Data di ultima trasmissione',
      oneWeek: 'Una settimana',
      oneMonth: 'Un mese',
      threeMonths: 'Tre mesi',
      customize: 'Personalizza',
      transmittingLabel: 'Non trasmettono da',
      verifyTransmissionOBU: 'OBU verifica trasmissione',
      associatedVehicle: 'Veicolo associato',
      selectTimer: 'Seleziona timer in secondi'
    },
    info: {
      dataUsedByUser: 'Dati utilizzati dall\'utente',
      noLogsInLast: 'Nessuna funzione utilizata negli ultimi',
      driverNotAssociated: 'Non associato',
      vehicleAlreadyDisabled: 'Il veicolo risulta disabilitato per la data della notifica',
      schedulingDateIsLessThanToday: 'Non è possibile abilitare una notifica per un giorno passato',
      canNotDisableIfHasOBU: 'Rimuovere l\'OBU prima di selezionare una data di disabilitazione',
      areYouSureTo: 'Si è sicuri di voler',
      allConfigsAreSelected: 'L\'amministratore di default possiede tutti i permessi della configurazione',
      disableUserCheck: 'Si è sicuri di voler disabilitare',
      operatorCanModifyOnlyOperators: 'L\'utenza in uso può disabilitare solo gli operatori',
      canNotDisableAnotherAdmin: 'Non è possibile disabilitare un amministratore',
      operationMandatoryInfo1: 'Per una corretta gestione delle scadenze degli interventi è necessario assegnare un valore ad almeno uno dei campi tra',
      operationMandatoryInfo2: 'Dopo aver configurato gli indirizzi di posta nella sezione',
      operationMandatoryInfo3: 'sarà possibile ricevere, per ogni scadenza imminente relativa ad una',
      operationMandatoryInfo4: 'data e/o ad un certo chilometraggio',
      operationMandatoryInfo5: 'un messaggio di posta come',
      operationMandatoryInfo6: 'e con le',
      operationMandatoryInfo7: 'principali informazioni dell’intervento schedulato',
      runningOut: 'km in esaurimento',
      exhaustedKm: 'km esauriti',
      regular: 'Situazione km regolare',
      notDefinable: 'Non definibile',
      infoModal: 'Informazioni dettagliate',
      vehicleHasKm: 'Il veicolo possiede ancora',
      missingLessThan: 'Mancano meno di',
      vehicleRegularStatus: 'Il veicolo è lontano dal raggiungimento del massimo chilometraggio impostato nel noleggio',
      vehicleIsRunningOut: 'Il veicolo è vicino al raggiungimento del massimo chilometraggio impostato nel noleggio',
      vehicleRentalExhausted: 'Il veicolo ha superato il limite di distanza percorribile impostato nel noleggio',
      updateVehicleAutomaticDate: 'I km rilevati dal GPS vengono allineati quotidianamente alle ore 02:00 e vengono sincronizzati con l’ultimo chilometraggio inserito manualmente.',
      driverResigned: 'Autista attualmente non in servizio',
      emptyPositions: 'Non sono state rilevate posizioni',
      needAtLeastOneEmail: 'è richiesto almeno un indirizzo di posta elettronica valido',
      willBeEnabledNotification: 'Al salvataggio verrà abilitata la possibilità di ricevere notifiche automatiche in base alla configurazione selezionata',
      toChangeConfig: 'Per modificare la configurazione cliccare sulla scorciatoia',
      threshold: '',
      notificationEnabled: 'L\'intervento verrà notificato in base alla configurazione dei gruppi di notifica e i gruppi di promemoria',
      notificationDisabled: 'L\'intervento NON verrà notificato',
      remainingKmInfo1: 'La funzione restituisce l\'elenco di tutti i veicoli che hanno un contratto di utilizzo ' +
        'vincolato ad un numero di km di percorrenza prestabilito, che va inserito nell\'anagrafica del veicolo.',
      remainingKmInfo2: 'Inserendo un numero di',
      remainingKmInfo3: 'in questo campo di selezione,' +
        ' si otterrà l\'elenco dei veicoli che hanno un residuo di km di percorrenza minore o uguale al valore indicato.',
      remainingKmInfo4: 'ES: Impostando il valore a 30.000 KM si ottiene l\'elenco dei veicoli che hanno' +
        ' ancora un percorrenza utile minore o uguale a 30.000 Km rispetto la valore contrattualizzato (Bollino VERDE)\n' +
        'Se il numero di Km contrattualizzati è stato superato comparirà un indicatore (Bollino ROSSO)\n' +
        'La selezione può essere ulteriormente affinata (vedi il campo ',
      thresholdInfoModal1: 'Impostando un valore di',
      thresholdInfoModal2: 'si ottiene l\'evidenza (Bollino GIALLO) di quei veicoli che ' +
        '(pur rientrano nella selezione effettuata tramite il valore',
      thresholdInfoModal3: 'hanno un numero di Km residuo rispetto al contratto minore o uguale al valore di soglia.',
      thresholdInfoModal4: 'Questo campo può essere utilizzato per evidenziare automaticamente ' +
        'le situazioni più critiche all\'interno del gruppo di veicoli selezionato.\n' +
        'La situazione ottenuta può essere esportata per elaborazioni o report di varia natura.\n',
      thresholdInfoModal5: 'Si ottiene l\'elenco dei veicoli che hanno una percorrenza residua di almeno 30.000 Km ' +
        '( o minore) con l\'evidenza (Bollino GIALLO) di quelli che hanno una percorrenza residua minore o uguale a 2.500 Km.',
      enumConfig1: 'Attenzione: ' +
        'la modifica o cancellazione degli indirizzi di mail associati al servizio non sarà applicata alle richieste di notifica già attive.',
      enumConfig2: 'I nuovi indirizzi saranno utilizzati nelle prossime attivazioni.',
      hasService: 'Possiede',
      hasNoService: 'Non possiede',
      allFieldsInPositionReportRequired: 'Inserire tutti i filtri per una nuova ricerca (massimo 12 ore di resoconto)',
      awdocAuthorized: 'Per visualizzare e caricare allegati, è necessario accedere con le proprie credenziali all\'indirizzo ' + BASE_URL_FRONTEND + '/awdoc'
    },
    success: {
      postSuccess: 'aggiunto con successo',
      putSuccess: 'aggiornato con successo',
      sendMail: 'inviata con successo',
      fileUpload: 'File caricato con successo',
      fileDeleted: 'File eliminato con successo'
    },
    warnings: {
      motivationRequired: 'Per la conformità alle normative sulla privacy è necessario selezionare una delle motivazioni previste per l\'accesso alla tipologia di dati richiesta',
      adminCanNotEditDefaultAdmin: 'Gli utenti con ruolo Amministratore non possono alterare lo stato delle utenze "Admin di default"',
      atLeastDefaultAdminNeeded: 'L\'applicazione necessita di almeno un "Amministratore di Default" per il corretto funzionamento',
      adminCanOnlyCreateOtherAdmins: 'Azione non permessa, un amministratore può solo creare altri amministratori',
      accessDenied: 'Accesso negato',
      alreadyDisabled: 'L\'utente risulta già disabilitato',
      checkDate: 'Errore nella data, ricontrollare prima di proseguire',
      canNotBeBefore: 'non può essere minore di | non possono essere minori di',
      invalid: 'Non valido | Non valida',
      dateError: 'Errore nella data, controllare prima di proseguire',
      sureToDelete: 'Si è sicuri di voler eliminare l\'elemento',
      continue: 'Prosegui',
      valid: 'Valido | Valida',
      notSavedTabChanges: 'Cambiando scheda le modifiche verrano perse, continuare?',
      onlyExcel: 'Vengono accettati solo file di tipo xls, xlsx o ods',
      fileHasDifferentLang: 'La lingua del file è diversa dalla lingua del browser. Cambiare la lingua del browser o del file.',
      fileIsEmpty: 'Il file risulta vuoto',
      association: 'Errore durante l\'associazione tra',
      serviceNotFound: 'Servizio non trovato',
      resetSavedPosition: 'Salvando le nuove informazioni, la posizione precedentemente acquisita verrà persa, continuare?',
      chooseStatus: 'E\' obbligatorio scegliere uno stato per questa verifica:',
      disputeNotSavable: 'Non è possibile presentare una contestazione in quanto la verifica risulta accettata',
      notificationNotSavable: 'Non è possibile inviare una notifica al dipendente in quanto una o più condizioni di notifica non sono rispettate',
      verificationNotReopenable: 'Non è possibile riaprire la verifica: ',
      employeeNotificationSent: 'è già stata inviata la notifica di rimborso al dipendente',
      disputeSent: 'è già stata inviata la contestazione'

    },
    errors: {
      noStaffAdd: 'L\'utente non è abilitato nell\'aggiunta del personale',
      noStaffEdit: 'L\'utente non è abilitato nella modifica del personale',
      userIsDisabled: 'La sua utenza risulta disabilitata, rivolgersi a un amministratore.',
      inUse: 'L\'elemento selezionato è già stato utilizzato e non può essere rimosso',
      generic: 'Qualcosa è andato storto',
      unusual: 'Elemento già esistente',
      login: 'Utente o password errati',
      surnameLength: 'Errore nel cognome(*), la lunghezza non è stata rispettata. (50 caratteri)',
      nameLength: 'Errore nel nome(*), la lunghezza non è stata rispettata. (50 caratteri)',
      taxCode: 'Errore nel codice fiscale, non risulta valido',
      badgeLength: 'Errore nel numero di cartellino, la lunghezza massima ammessa è di 20 caratteri',
      keyCodeError: 'Errore nel numero di chiave, la lunghezza massima ammessa è di 40 caratteri',
      invalidDate: 'Non è una data valida (AAAA-MM-GG)',
      invalidContractData: 'Le date contrattuali risultano cronologicamente NON valide',
      errorsList: 'Lista errori',
      duplicateTaxCode: 'Il codice fiscale inserito esiste già nel sistema',
      fileUpload: 'Impossibile caricare file',
      fileDeleted: 'Impossibile eliminare file',
      fileDownloaded: 'Impossibile scaricare file',
      fileFormat: ' Il file inserito non ha un formato valido'
    },
    months: {
      january: 'Gennaio',
      february: 'Febbraio',
      march: 'Marzo',
      april: 'Aprile',
      may: 'Maggio',
      june: 'Giugno',
      july: 'Luglio',
      august: 'Agosto',
      september: 'Settembre',
      october: 'Ottobre',
      november: 'Novembre',
      december: 'Dicembre'
    },
    constraints: {
      user_name: 'Nome utente duplicato',
      contract_number: 'Numero di contratto duplicato.',
      tracker_imei: 'IMEI già presente nel sistema.',
      vehicle_plate: 'Targa già presente per il customer.',
      vehicle_tracker: 'Tracciatore assiciato a più veicoli.',
      asset_tag: 'Codice tag duplicato.',
      asset_code: 'Codice strumento duplicato.',
      enum_descr: 'Descrizione enumerativo duplicata.',
      recipient_descr: 'Descrizione lista destinatari duplicata.'
    },
    dimetiorHttpCode: {
      400: {
        2: 'Errore durante la lettura o l\'interpretazione di un parametro in ingresso.',
        10: 'Errore durante l\'inserimento o la modifica di un entità dovuto alla violazione di un constraint di univocità',
        11: 'Errore durante l\'inserimento o la modifica di un entità dovuto alla violazione di un constraint su una o più colonne'
      },
      403: 'Accesso negato',
      404: {
        0: 'Risorsa non trovata',
        3: 'Risorsa non trovata',
        5: 'Risorsa non trovata'
      },
      409: {
        7: 'Conflitto durante la rimozione'
      },
      413: 'Dimensione dei dati troppo grande',
      422: {
        3: 'Errore durante la comunicazione'
      },
      423: 'La password risulta scaduta',
      440: 'La sessione risulta scaduta',
      500: {
        1: 'Errore imprevisto lato server',
        4: 'Chiave non permessa',
        5: 'Spazio insufficente per aggiungere una nuova chiave',
        6: 'Chiave in fase di modifica',
        7: 'Indice chiave non corretto',
        8: 'Impossibile aggiornare le informazioni del tracker',
        9: 'Impossibile aggiornare il comando'
      },
      502: 'Errore 502, errore di comunicazione'
    },
    violazioniHttpCode: {
      400: {
        1: 'Formato ID non valido',
        2: 'Errore durante la lettura o l\'interpretazione di un parametro in ingresso',
        3: 'Errore durante l\'inserimento o la modifica di un entità dovuto alla violazione di un constraint di univocità'
      },
      401: 'Non è stato possibile connettersi al server delle violazioni',
      403: 'Accesso negato',
      404: {
        5: 'Risorsa non trovata'
      },
      409: {
        4: 'Errore durante l\'inserimento o la modifica di un entità dovuto alla violazione di un constraint'
      },
      422: {
        2: 'Errore durante la validazione dell\'entità inviata nel body della richiesta'
      },
      423: 'La password risulta scaduta',
      500: {
        6: 'Errore imprevisto lato server'
      }
    },
    path: {
      '/recipients': 'Destinatari',
      '/insurance': 'Polizze',
      '/home': 'Home',
      '/map': 'Mappa interattiva',
      '/organization': 'Organizzazione',
      '/configuration': 'Configurazione',
      '/obu_management': 'Gestione OBU',
      '/logout': 'Uscita',
      '/login': 'Accesso',
      '/application_logs': 'Log',
      '/customer': 'Utente',
      '/customers': 'Utenti',
      '/user': 'Utente',
      '/users': 'Utente',
      '/trackers': 'OBU',
      '/position': 'Posizione',
      '/positions': 'Posizioni',
      '/vehicles': 'Veicolo',
      '/operations': 'Intervento',
      '/scheduling': 'Intervento',
      '/accidents': 'Incidente',
      '/drivers': 'Personale',
      '/driversbyvehicle': 'Personale',
      '/alarm': 'Allarme',
      '/alarmdefs': 'Allarme',
      '/device_command': 'Configurazione OBU',
      '/fleets': 'Flotta',
      '/recipients_list': 'Destinatari',
      '/report': 'Report',
      '/assets': 'Asset',
      '/tags': 'Tag',
      '/blescans': 'Scansione',
      '/lastscans': 'Scansione',
      '/warehouses': 'Magazzino',
      '/enums/document_type': 'Tipo documento',
      '/enums/fuel_type': 'Tipo carburante',
      '/enums/owner': 'Proprietario',
      '/enums/insurance_company': 'Compagnia assicurativa',
      '/enums/company': 'Compagnia',
      '/enums/vehicle_state': 'Stato veicolo',
      '/enums/activity_sector': 'Settore attività',
      '/enums/registry_code': 'Codice ALBO',
      '/enums/service_type': 'Tipo servizio',
      '/enums/equipment': 'Equipaggiamento',
      '/enums/classification': 'Classificazione',
      '/enums/accident_state': 'Stato incidente',
      '/enums/asset_type': 'Tipo asset',
      '/enums/driving_license': 'Patente',
      '/enums/operation': 'Intervento',
      '/enums/user_type': 'Tipo utente',
      '/penalty_charge_notice': 'Gestione multe',
      '/motivations_registry': 'Anagrafica motivazioni'
    },
    motivation: {
      assessment: 'accertamento stradale e/o amministrativo',
      assistance: 'assistenza all\'autista',
      securityCheck: 'Sospetto furto',
      availableCheck: 'Verifica disponibilità mezzo',
      parkingCheck: 'Localizzazione parcheggio',
      OBUCheck: 'verifica funzionamento OBU'
    }
  }
}

export default messages
